module.exports = __webpack_public_path__ + "fonts/Inter-500-greek-ext52.318d4ba.woff2";